const getCommentsFromIds = (
  data: Assignment | Project,
  id?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  switch (id) {
    case 'reference_files_design_content':
      return data?.design_content
    case 'reference_files_other_references':
      return data?.design_other_references
    case 'references_logo_files':
      return data?.design_references_logo_files
    case 'references_brand_style_guide':
      return data?.design_references_brand_style_guide
    case 'adapts_main_design':
      return data?.design_adapts_main_design
    case 'reference_files_infographic_description':
      return data?.design_infographic_description
    case 'outline_structure':
      return data?.outline_structure &&
        Object.prototype.hasOwnProperty.call(data?.outline_structure, 'comment')
        ? data?.outline_structure?.comment
        : data?.outline_structure
    case 'other_instructions':
      return data?.other_instructions &&
        Object.prototype.hasOwnProperty.call(
          data?.other_instructions,
          'comment'
        )
        ? data?.other_instructions?.comment
        : data?.other_instructions
    case 'other_information':
      return data?.other_information &&
        Object.prototype.hasOwnProperty.call(data?.other_information, 'comment')
        ? data?.other_information?.comment
        : data?.other_information
    default:
      return ''
  }
}

export default getCommentsFromIds
